import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges  } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,VisiteService } from '../../../../../services'

const KEY = 'dossier-rdv-formulaires'

@Component({
  selector: 'atyl-dossier-rdv-formulaires',
  templateUrl: './dossier-rdv-formulaires.component.html',
  styleUrls: ['./dossier-rdv-formulaires.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-rdv-formulaires',
  key: KEY,
})
export class DossierRdvFormulairesComponent implements OnInit, OnChanges {

  @Input() displayFormulaires: any[] = [];
  @Input() visiteID: number = 0;
  @Input() demandes: any[] = [];
  @Input() tiers: any
  @Input() visite: any
  @Output() onAddFormulaire: EventEmitter<MouseEvent> = new EventEmitter(null);
  @StringableValues(KEY) strings: any
  expanded: boolean = true;
  @Input() dossier: any;

  user : any;
  
  eventDossier:any;
  
  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private visiteService: VisiteService
  ) { }

  ngOnInit() {
	
	if (this.dossier==undefined)
	    this.eventDossier=this.stateService.dossier.subscribe(dossier => {
	      if (dossier) {
	        this.dossier = dossier
	        this.tiers = dossier.tiers
	      }
	    });
		
    console.log("init DossierRdvFormulairesComponent",this.demandes);
    this.stateService.user.subscribe((user) => {
        if (user) {
            this.user = user;
            console.log("user dossier rdvForm",this.user);
            this.demandes = this.setObjectUserRights(this.demandes, 'demande');
        }

    })
  }
  
  ngOnDestroy() {
  		if (this.eventDossier)
  			this.eventDossier.unsubscribe();
  		
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.demandes && !changes.demandes.firstChange) {
        this.demandes = this.setObjectUserRights(this.demandes, 'demande');
    }
  }


  openFormulaire(demande: any) {
    
    console.log("demande rdv openFormulaire",demande);
     let dataSF={
         dossier: this.dossier,
         v3: true,
         closeWhenValidate: true,
        // visite: (this.visite!=undefined && this.visite.ID!=undefined) ? this.visite.ID:  demande.ID
		visite:  demande.ID
    };
    if (demande.demande!=undefined) {
        dataSF["id"]=demande.demande.ID;
        dataSF["title"]=demande.demande.libelle;
        dataSF["formType"]=demande.demande.key;
        dataSF["idDemandeForm"]=demande.demande.form.ID;
        /*
        let datasF = {
                    title: form.libelle,
                    id: demandeForm.ID,
                    formType: demandeForm.key,
                    idDemandeForm: form.ID,
                }
         */ 
         
               
        
    } else {
        dataSF["create"]=true;
        dataSF["idAForm"]=demande.action.IdForm;
        dataSF["title"]=demande.action.libelle;
        /*
         data: {
                    idAForm: button.IdForm,
                    dossier: this.dossier ? this.dossier : "",
                    create: true,
                    closeWhenValidate: true,
                    action: button,
                    v3: true,
                },
          */      
        
    }
    if(demande.editable != undefined){
        dataSF["isEditable"]=demande.editable;
    }
	
	if (dataSF["isEditable"]
		 && demande.demande!=undefined
		 && demande.demande.verrouille!=undefined  
		 && demande.demande.verrouille  )
		dataSF["isEditable"]=false;
     
    if (this.visite!=undefined && this.visite.date_debut!=undefined)
		dataSF["date_debut"]=this.visite.date_debut;
	if (this.visite!=undefined && this.visite.date_fin!=undefined)
		dataSF["date_fin"]=this.visite.date_fin;
			
   
      console.log('openFormulaire rdv',dataSF, demande,this.visite);
    
    this.dialogService.open(FormDialogFormulaireWithSFComponent, {
      data: dataSF,
      height: '90vh',
      width: "90vw",
      draggable: true,
      resizable: true,
      maximizable: true,
      minimizable: true,
    }, (result) => {
            if (result) {
                console.log("ressh ID");
				let _opts:any={
				/*	IsVisitDemande:false		*/		
				}
				 this.visiteService.getFormulaireDemande(this.visiteID).subscribe((res: JSONRpcResponse) => {
					if (res.result && res.result.demandes!=undefined && res.result.demandes) {
						this.demandes=res.result.demandes;
						if (this.changeDetector && !(this.changeDetector as ViewRef).destroyed) {
						                                        this.changeDetector.detectChanges()
						    }
					}
				});	
                /*this.visiteService.get(this.visiteID,_opts).subscribe((res: JSONRpcResponse) => {
                             if (res.result && res.result.demandes!=undefined && res.result.demandes) {
                                 this.demandes=res.result.demandes;
                                 if (this.changeDetector && !(this.changeDetector as ViewRef).destroyed) {
                                        this.changeDetector.detectChanges()
                                  }
                                
                               }
                            }
                        )*/
           }             
      })
    
  }
  addFormulaire(event: MouseEvent) {
    this.onAddFormulaire.emit(event)
  }

  
  setObjectUserRights(obj: any | any[], type: string) {
    if (Array.isArray(obj)) {
        obj.forEach((item: any) => {
            item = this.applyRightsObj(item, type);
        });
    } else {
        obj = this.applyRightsObj(obj, type);
    }
    return obj;
	}

	applyRightsObj(obj: any, type: string) {
	    let rg: any = {
	        r: true,
	        w: true,
	        x: true
	    };
	    let key = null;
	    
	    switch (type) {
	        case "demande":
	            key = obj.action.CodeForm;
	            type="formulaire"
	            break;
	    }
	    if (this.user.droitsObjets != undefined && this.user.droitsObjets[type] != undefined) {
	        if (this.user.droitsObjets[type][key] != undefined) {
	            rg = this.user.droitsObjets[type][key];
	        }
	    }
	
	    if(this.visite && this.visite.rights){
	        let newRights = {};
	        for(let right of ["r","w","x"]){
	            newRights[right] = rg[right]? this.visite.rights[right]: false
	        }
	        rg = newRights;
	    }
	
	    obj.rights = rg;
	
	    // Si l'objet est éditable, vérifier s'il est modifiable
	    if (obj.editable == undefined || obj.editable) {
	        obj.editable = rg.w;
	    }
	
	    return obj;
	}

	lock_unlock(form:any) {
		   console.log("form lock event_unlock visit",form)
		//	this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
		this.visiteService.getFormulaireDemande(this.visiteID).subscribe((res: JSONRpcResponse) => {
						if (res.result && res.result.demandes!=undefined && res.result.demandes) {
							this.demandes=res.result.demandes;
							if (this.changeDetector && !(this.changeDetector as ViewRef).destroyed) {
							                                        this.changeDetector.detectChanges()
							    }
						}
		});	
		
	}



}
